const LocalEvent = function (item) {
  this.get = function () {
    return localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : ''
  }
  this.set = function (obj) {
    localStorage.setItem(item, JSON.stringify(obj))
  }
  this.clear = function () {
    localStorage.removeItem(item)
  }
}

export const userInfo = new LocalEvent('data')
export const showPage = new LocalEvent('info')
export const getDate = () => {
  const now = new Date()
  const dateTime = now.getFullYear() + '-' + ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1) + '-' + (now.getDate() < 10 ? '0' : '') + now.getDate()
  return dateTime
}



// WEBPACK FOOTER //
// ./src/store/localStorage.js